/* eslint-disable react/destructuring-assignment */
import React from 'react';
import { Link as RebassLink } from 'rebass';
import { Link as RouterLink } from 'react-router-dom';
import styled from 'styled-components';
import colors from '../theme/colors';

const StyledLink = styled(RebassLink as any)`
  cursor: pointer;
  color: ${props => props.color};
  text-decoration: ${props => (props.underline ? 'underline' : 'none')};
  text-align: center;
  user-select: none;
  font-weight: bold;
  &:hover {
    color: ${props => props.hover};
  }
`;

const Link: React.FC<any> = props => (
  <StyledLink as={props.to ? RouterLink : RebassLink} {...props} />
);

StyledLink.defaultProps = {
  color: colors.white,
  hover: colors.white,
};

export default Link;
